"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var ReactDom = require("react-dom");

var ZIndexLayers_1 = require("../../common/ZIndexLayers");

var withStyles_1 = require("../../decorators/withStyles");

var ListItem_1 = require("./ListItem");

var Hr_1 = require("../../Hr/Hr");

var Paper_1 = require("../../Tooltip/Paper");

var modsClassName_1 = require("../../assets/modsClassName");

var classNames = require("classnames");

var defaultControlHeight = 33;
var windowPadding = 10;
var optimalSpaceThreshold = 280;
var controlTopPadding = 3;

var List =
/** @class */
function (_super) {
  __extends(List, _super);

  function List() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(List.prototype, "children", {
    get: function get() {
      var _this = this;

      var _a = this.props,
          onClick = _a.onClick,
          itemsJsx = _a.itemsJsx,
          classes = _a.classes,
          minWidth = _a.minWidth,
          maxWidth = _a.maxWidth,
          testId = _a.testId,
          pureList = _a.pureList;
      var className = classNames(classes.base, !pureList ? classes.list : classes.pure, modsClassName_1.modsClassName(this.props, 'right'));
      var inlineStyles = {
        minWidth: minWidth,
        maxWidth: maxWidth
      };

      if (maxWidth) {
        inlineStyles.overflowX = 'hidden';
      }

      return React.createElement("div", {
        "data-test-id": testId,
        className: className,
        onClick: onClick,
        ref: function ref(element) {
          return _this.listElement = element;
        }
      }, React.createElement(Paper_1.default, {
        mode: "dropdown"
      }, React.createElement("div", {
        style: inlineStyles,
        className: classes.scrollViewport,
        ref: function ref(element) {
          return _this.scrollViewportElement = element;
        }
      }, this.pinnedItems, React.createElement("div", {
        className: classes.items
      }, itemsJsx)), this.footer));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(List.prototype, "pinnedItems", {
    get: function get() {
      var _a = this.props,
          classes = _a.classes,
          pinnedItems = _a.pinnedItems;

      if (!pinnedItems || !pinnedItems.length) {
        return null;
      }

      return React.createElement("div", null, React.createElement("div", {
        className: classes.items
      }, pinnedItems), React.createElement(Hr_1.default, {
        oversize: false
      }));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(List.prototype, "footer", {
    get: function get() {
      var _a = this.props,
          classes = _a.classes,
          footerContent = _a.footerContent,
          onFooterClick = _a.onFooterClick,
          FooterComponent = _a.FooterComponent;
      var showFooter = footerContent || FooterComponent;
      return showFooter ? React.createElement("div", null, React.createElement(Hr_1.default, {
        oversize: false
      }), React.createElement("div", {
        className: classes.items
      }, !FooterComponent ? React.createElement(ListItem_1.default, {
        text: footerContent,
        onClick: onFooterClick
      }) : FooterComponent)) : null;
    },
    enumerable: true,
    configurable: true
  });

  List.prototype.render = function () {
    var container = this.props.container;

    if (container) {
      if (!this.touchStartHandled) {
        container.addEventListener('touchstart', function (evt) {
          // при использовании порталов на touch-устройствах событие touchstart
          // срабатывает раньше события click
          // внутри себя реакт-селект проверяет, что touch происходит ВНУТРИ контейнера
          // и закрывает выпадушку в противном случае, из-за этого выпадушка дропдауна
          // закрывается раньше, чем успевает обработаться клик по элементу меню
          evt.stopPropagation();
        });
        this.touchStartHandled = true;
      }

      return ReactDom.createPortal(this.children, container);
    }

    return this.children;
  };

  List.prototype.componentDidMount = function () {
    var _a = this,
        listElement = _a.listElement,
        scrollViewportElement = _a.scrollViewportElement,
        props = _a.props;

    var customMaxHeight = props.customMaxHeight,
        customMinHeight = props.customMinHeight,
        forceBottom = props.forceBottom,
        theme = props.theme,
        focused = props.focused,
        pureList = props.pureList;
    var clientRect = listElement.getBoundingClientRect();
    var viewportRect = scrollViewportElement.getBoundingClientRect();
    var viewportHeightOffset = clientRect.height - viewportRect.height;
    var controlHeight = theme ? theme.sizeControlHeight + theme.sizeBorderWidth : defaultControlHeight;

    var _b = adjustHeightAndPosition({
      clientRect: clientRect,
      window: window,
      controlHeight: controlHeight,
      windowPadding: windowPadding,
      controlTopPadding: controlTopPadding,
      optimalSpaceThreshold: optimalSpaceThreshold,
      customMaxHeight: customMaxHeight,
      customMinHeight: customMinHeight,
      forceBottom: forceBottom
    }),
        top = _b.top,
        maxHeight = _b.maxHeight,
        height = _b.height;

    if (!pureList) {
      listElement.style.top = px(top);
    }

    var maxHeightValue = maxHeight - viewportHeightOffset;
    var heightValue = height - viewportHeightOffset;
    scrollViewportElement.style.maxHeight = px(maxHeightValue);
    scrollViewportElement.style.height = px(heightValue);

    if (focused && focused.focusedRef) {
      var focusedOptionNode = ReactDom.findDOMNode(focused.focusedRef);
      this.scrollViewportElement.scrollTop = focusedOptionNode.offsetTop - (heightValue || maxHeightValue) + focusedOptionNode.offsetHeight + 5;
    }
  };

  List = __decorate([withStyles_1.withStyles(function (_a) {
    var colorBg = _a.colorBg,
        depth2 = _a.depth2,
        colorBorder = _a.colorBorder,
        sizeControlHeight = _a.sizeControlHeight,
        sizeBorderWidth = _a.sizeBorderWidth;
    return {
      base: {
        fontSize: 15,
        zIndex: ZIndexLayers_1.default.DROPDOWN_MENU
      },
      list: {
        position: 'absolute',
        top: sizeControlHeight - 2 * sizeBorderWidth,
        left: '-1px'
      },
      pure: {
        position: 'relative'
      },
      right: {
        left: 'auto',
        right: '-1px'
      },
      items: {
        padding: '5px 0'
      },
      scrollViewport: {
        overflowX: 'auto'
      }
    };
  })], List);
  return List;
}(React.Component);

exports.default = List;
/**
 *
 * @param {{top: number; height: number}} clientRect
 * @param {{innerHeight: number}} window
 * @param {number} optimalSpaceThreshold
 * @param {number} windowPadding
 * @param {number} controlHeight
 * @param {number} controlTopPadding
 * @param {number} [customMaxHeight] максимальная высота, задаётся вручную
 * @param {number} [customMinHeight] минимальная высота, задаётся вручную
 * @param {boolean} [forceBottom] всегда открывать дропдаун снизу
 * @returns {React.CSSProperties}
 */

function adjustHeightAndPosition(_a) {
  var clientRect = _a.clientRect,
      window = _a.window,
      optimalSpaceThreshold = _a.optimalSpaceThreshold,
      windowPadding = _a.windowPadding,
      controlHeight = _a.controlHeight,
      controlTopPadding = _a.controlTopPadding,
      customMaxHeight = _a.customMaxHeight,
      customMinHeight = _a.customMinHeight,
      forceBottom = _a.forceBottom;
  var clientHeight = customMaxHeight ? Math.min(customMaxHeight, clientRect.height) : clientRect.height;
  var availableTopHeight = clientRect.top - windowPadding - controlHeight;
  var availableBottomHeight = window.innerHeight - clientRect.top - windowPadding;

  var isGood = function isGood(availableHeight) {
    return availableHeight >= optimalSpaceThreshold || clientHeight <= availableHeight;
  };

  var isBottomGood = isGood(availableBottomHeight);
  var isTopGood = isGood(availableTopHeight);

  if (!isBottomGood && isTopGood && !forceBottom) {
    // Показываем выпадашку сверху
    var height = Math.min(availableTopHeight, clientHeight + controlTopPadding);
    return {
      top: -height,
      height: height - controlTopPadding
    };
  } else {
    // Показываем выпадашку снизу
    var maxHeight = customMaxHeight ? customMaxHeight : availableBottomHeight;
    return {
      top: controlHeight,
      maxHeight: customMinHeight ? Math.max(customMinHeight, maxHeight) : maxHeight
    };
  }
}

exports.adjustHeightAndPosition = adjustHeightAndPosition;

function px(value) {
  return isNaN(value) ? '' : value + "px";
}